import type { SessionDetails } from '@/src/dal/session-dal'

function noteLabel(value: string | null | undefined): string | null {
  return value != null && value.length > 0 ? value : null
}

/** Renders backend note strings as a range label, e.g. `c1 - g2`. */
export function noteRangeLabel(
  from: string | null | undefined,
  to: string | null | undefined,
): string | null {
  const fromNote = noteLabel(from)
  const toNote = noteLabel(to)

  if (fromNote != null && toNote != null) {
    return `${fromNote} - ${toNote}`
  }

  return fromNote ?? toNote
}

export function hasSessionAnalysisMetrics(session: SessionDetails): boolean {
  return (
    session.score != null ||
    noteLabel(session.comfortableMin) != null ||
    noteLabel(session.comfortableMax) != null ||
    noteLabel(session.pitchMin) != null ||
    noteLabel(session.pitchMax) != null
  )
}
